import { render, staticRenderFns } from "./ResendApiEvent.vue?vue&type=template&id=653334bc&"
import script from "./ResendApiEvent.vue?vue&type=script&lang=js&"
export * from "./ResendApiEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports